var React = require('react');

function PhoneInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.905 1.75C2.95 2.4175 3.0625 3.07 3.2425 3.6925L2.3425 4.5925C2.035 3.6925 1.84 2.74 1.7725 1.75H2.905ZM10.3 10.765C10.9375 10.945 11.59 11.0575 12.25 11.1025V12.22C11.26 12.1525 10.3075 11.9575 9.4 11.6575L10.3 10.765ZM3.625 0.25H1C0.5875 0.25 0.25 0.5875 0.25 1C0.25 8.0425 5.9575 13.75 13 13.75C13.4125 13.75 13.75 13.4125 13.75 13V10.3825C13.75 9.97 13.4125 9.6325 13 9.6325C12.07 9.6325 11.1625 9.4825 10.3225 9.205C10.2475 9.175 10.165 9.1675 10.09 9.1675C9.895 9.1675 9.7075 9.2425 9.5575 9.385L7.9075 11.035C5.785 9.9475 4.045 8.215 2.965 6.0925L4.615 4.4425C4.825 4.2325 4.885 3.94 4.8025 3.6775C4.525 2.8375 4.375 1.9375 4.375 1C4.375 0.5875 4.0375 0.25 3.625 0.25Z","fill":"#363636"}));
}

PhoneInline.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = PhoneInline;

PhoneInline.default = PhoneInline;
